import { Action, createReducer, on } from "@ngrx/store";
import { UserAction } from "./user.action";
import { AccountSettingActions } from "../../account-setting/state/account-setting.actions";
import { User } from "../../core/model/user.model";

export const STORE_FEATURE_KEY_USERS = "users";

export interface UsersState {
  selectedUser: User;
  searchUsers: Array<any>;
  usersSearchLoading: boolean;
  loadingIndicator: boolean;
  templates: Array<any>;
  selectedUserAccountSetting: any;
  hasFeaturesChanged: boolean;
}

export const initializeUsersState: UsersState = {
  selectedUser: undefined,
  searchUsers: [],
  usersSearchLoading: false,
  templates: [],
  loadingIndicator: false,
  selectedUserAccountSetting: undefined,
  hasFeaturesChanged: false,
};

const reducer = createReducer<UsersState>(
  initializeUsersState,
  on(UserAction.searchUser, (state, payload) => ({
    ...state,
    usersSearchLoading: true,
    selectedUser: undefined,
    selectedUserAccountSetting: undefined,
    searchUsers: undefined,
  })),
  on(UserAction.searchUserSuccess, (state, { user }) => ({
    ...state,
    usersSearchLoading: false,
    searchUsers: user,
    selectedUser: undefined,
    selectedUserAccountSetting: undefined,
  })),
  on(UserAction.searchUserFail, (state, payload) => ({
    ...state,
    usersSearchLoading: false,
    selectedUser: undefined,
    selectedUserAccountSetting: undefined,
  })),
  on(UserAction.getSelectedUserById, (state, payload) => ({
    ...state,
    selectedUser: undefined,
    usersSearchLoading: true,
    selectedUserAccountSetting: undefined,
  })),
  on(UserAction.getSelectedUserByIdSuccess, (state, { selectedUser }) => ({
    ...state,
    selectedUser: selectedUser,
    usersSearchLoading: false,
  })),
  on(UserAction.getTemplatesByUserId, (state, payload) => ({
    ...state,
    templates: [],
    loadingIndicator: true,
  })),
  on(UserAction.getTemplatesByUserIdSuccess, (state, { payload }) => ({
    ...state,
    templates: payload.templates,
    loadingIndicator: false,
  })),
  on(UserAction.getTemplatesByUserIdFail, (state, payload) => ({
    ...state,
    loadingIndicator: false,
  })),
  on(
    AccountSettingActions.getAccountSettingsByUserIdSuccess,
    (state, settings) => ({
      ...state,
      selectedUserAccountSetting: settings.settings,
    })
  ),
  on(UserAction.getUserFeatures, (state, payload) => ({
    ...state,
    loadingIndicator: true,
    hasFeaturesChanged: false,
  })),
  on(UserAction.getUserFeaturesSuccess, (state, { features }) => ({
    ...state,
    selectedUser: { ...state.selectedUser, featurePermissions: features },
    loadingIndicator: false,
    hasFeaturesChanged: false,
  })),
  on(UserAction.getUserFeaturesFail, (state, { error }) => ({
    ...state,
    loadingIndicator: false,
    hasFeaturesChanged: false,
  })),
  on(UserAction.setUserFeatures, (state, { features }) => ({
    ...state,
    selectedUser: { ...state.selectedUser, featurePermissions: features },
    loadingIndicator: false,
    hasFeaturesChanged: true
  })),
  on(UserAction.setUserHasChangeFlag, (state, { value }) => ({
    ...state,
    hasFeaturesChanged: value
  })),
);

// tslint:disable-next-line:typedef only-arrow-functions
export function UsersReducer(state: UsersState | undefined, action: Action) {
  return reducer(state, action);
}
